module.exports = __webpack_public_path__ + "img/fueltype.234af41f.svg";